import { Component, OnInit, Input, ViewChild, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PropertyListingService } from '../../shared/providers/property-listing.service';
import { IPropertySearchCriteria } from '../../shared/models/propertysearchcriteria';
import { IPropertyCard, PropertyIdList } from '../../shared/models/propertycard';
import { DataTablesResponse } from '../../shared/models/datatables-response';
import { PropertyListingBase } from '../../property-listing/property-listing-base';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { IFilterable } from '../../property-listing/filterable';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { LoaderService } from '../../shared/providers/loader.service';
import { OpportunityOfferOutputModel } from '../../shared/models/OpportunityOfferOutputModel';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToastService } from '../../shared/providers/toast.service';
import { ValidationService } from '../../shared/providers/validation.service';
import { ActivatedRoute, Params } from '@angular/router';
import { ILookUp } from '../../shared/models/LookUpOutputModel';
import { CommonService } from '../../shared/providers/common.service';
import { collapseColumns } from '../../shared/models/collapseColumns';
import { Subject } from 'rxjs';

enum Actions {
  NothingSelected = 0,
  ChangeStatus = 1,
  MarkAsComp = 2,
  MarkAsArchive = 3,
  AssignBroker = 4,
  Delete = 5,
  MoveToLiveListing = 6
}
enum CompOrArhive {
  Comp = 1,
  Archive = 2,
  LiveListing = 6,
  Verify = 7
}

@Component({
  selector: 'archive-view',
  templateUrl: './archive.component.html'
})
export class ArchiveComponent extends PropertyListingBase implements IFilterable {
  currentPoint: number;
  propertiesEx: IPropertyCard[] = [];
  selectedRows: IPropertyCard[] = [];
  _takeCount = 5;
  @Input() searchCriteria: IPropertySearchCriteria;
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  user: any;
  dtOptions = {};
  role: string;
  offers: OpportunityOfferOutputModel[];
  //propertyCount: number;
  fromPage: string = "MyOffers";
  //IsArchive: string;
  archiveId: number;
  propertyIdList: PropertyIdList[];
  IsLoading = false;
  selectedColumns = [];
  //defaultTypeText: IMultiSelectTexts = {
  //  //checked: 'column selected',
  //  //checkedPlural: 'columns selected',
  //  defaultTitle: 'Select Columns',
  //};
  defaultTypeSettings = {
    singleSelection: false,
    text: "Select Columns",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
  }
  dtTrigger = new Subject();
  dataColums = [];
  constructor(private router: Router, protected http: HttpClient, protected _propertyListingService: PropertyListingService, public authService: AuthenticationService, protected loaderService: LoaderService, private modalService: BsModalService, private _toastService: ToastService, protected activatedRoute: ActivatedRoute, private Validation: ValidationService, private Common: CommonService, private cdRef: ChangeDetectorRef) {
    super(_propertyListingService, http, authService, loaderService, activatedRoute);

  }

  filter(searchParameters: IPropertySearchCriteria) {
    this.searchCriteria = searchParameters;
    if (this.dtElement.dtInstance) {
      this.dtElement.dtInstance.then(x => x.draw());
    }
  }
  viewDetail(guid: any) {
    this.router.navigate(['/viewproperty/' + guid]);
  }
  propertySearchCriteria(searchParameters: IPropertySearchCriteria) {
    //this.resetSelectedRows();
    this.currentPoint = 0;
    this.searchCriteria = searchParameters;
    const searchCriteria: IPropertySearchCriteria = {
      Address: this.searchCriteria.Address,
      AssetTypes: this.searchCriteria.AssetTypes,
      Ratings: this.searchCriteria.Ratings,
      PriceFrom: this.searchCriteria.PriceFrom,
      PriceTo: this.searchCriteria.PriceTo,
      SkipCount: this.currentPoint,
      SortValue: this.searchCriteria.SortValue,
      TakeCount: this._takeCount,
      Tenants: this.searchCriteria.Tenants,
      Terms: this.searchCriteria.Terms,
      IsMapView: false,
      Guid: this.searchCriteria.Guid,
      NOIFrom: this.searchCriteria.NOIFrom,
      NOITo: this.searchCriteria.NOITo,
      BuildingSizeFrom: this.searchCriteria.BuildingSizeFrom,
      BuildingSizeTo: this.searchCriteria.BuildingSizeTo,
      YearBuiltFrom: this.searchCriteria.YearBuiltFrom,
      YearBuiltTo: this.searchCriteria.YearBuiltTo,
      StateId: this.searchCriteria.StateId ? this.searchCriteria.StateId[0] : null,
      LeaseStructures: this.searchCriteria.LeaseStructures,
      CapRateFrom: this.searchCriteria.CapRateFrom,
      CapRateTo: this.searchCriteria.CapRateTo,
      PropertyStatus: this.searchCriteria.PropertyStatus,
      SubCategories: this.searchCriteria.SubCategories,
      IsRentAmount: this.searchCriteria.IsRentAmount,
      RentFrom: this.searchCriteria.RentFrom,
      RentTo: this.searchCriteria.RentTo,
      OwnershipTypes: this.searchCriteria.OwnershipTypes,
      IsExcludeSoldListing: this.searchCriteria.IsExcludeSoldListing,
      IsOnlySoldListing: this.searchCriteria.IsOnlySoldListing,
      IsExcludeContractListing: this.searchCriteria.IsExcludeContractListing,
      IsOnlyFeaturedListing: this.searchCriteria.IsOnlyFeaturedListing,
      LoggedInUserId: this.searchCriteria.LoggedInUserId,
      IsFavorite: this.searchCriteria.IsFavorite,
      PropertyFor: this.searchCriteria.PropertyFor,
      IsComp: this.searchCriteria.IsComp,
      IsArchive: this.searchCriteria.IsArchive,
      IsDisliked: this.searchCriteria.IsDisliked,
      IsSearchButtonClicked: this.searchCriteria.IsSearchButtonClicked,
      MinTerm: this.searchCriteria.MinTerm,
      MaxTerm: this.searchCriteria.MaxTerm,
      Brokerages: this.searchCriteria.Brokerages,
      States: this.searchCriteria.States,
      CharacteristicsId: this.searchCriteria.CharacteristicsId,
      AddressType: this.searchCriteria.AddressType,
      AddressTypeName: this.searchCriteria.AddressTypeName,
      AddressTypeId: this.searchCriteria.AddressTypeId,
      IsPortfolio: this.searchCriteria.IsPortfolio,
      PortfolioSaleOnly: this.searchCriteria.PortfolioSaleOnly,
      PropertySequenceId: this.searchCriteria.PropertySequenceId,
      DOMStartDate: this.searchCriteria.DOMStartDate == null ? null : this.Validation.utcify(this.searchCriteria.DOMStartDate),
      DOMEndDate: this.searchCriteria.DOMEndDate == null ? null : this.Validation.utcify(this.searchCriteria.DOMEndDate),
      TenantAddress: this.searchCriteria.TenantAddress,
      CityId: this.searchCriteria.CityId
    };
    super.holdPropertySearchCriteria(searchCriteria);
    this.searchCriteria = searchCriteria;
    this.BindColumns();
    if (this.dtElement.dtInstance) {
 this.dtElement.dtInstance.then(x => x.draw());
    }
    //if (this.dtElement.dtInstance) {
    //  this.dtElement.dtInstance.then((dtInstance) => {
    //    dtInstance.destroy();
    //    this.dtTrigger.next(true);
    //  });
    //}
  }

  onSearch(text: string) {
    this.dtElement.dtInstance.then(x => x.search(text).draw());
  }
  hasBrokerageFilter = false;
  hasTenantFilter = false;
  selectedAction = 0;
  propertyStatusList: ILookUp[];

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      console.log(params);
      if (params['brokerage']) {

        this.searchCriteria = {} as IPropertySearchCriteria;
        this.hasBrokerageFilter = true;
        this.searchCriteria.Brokerages = [];
        this.searchCriteria.Brokerages.push(parseInt(params['brokerage']));
        this.propertySearchCriteria(this.searchCriteria);
      }
      else if (params['TenantId']) {
        this.searchCriteria = {} as IPropertySearchCriteria;
        this.hasTenantFilter = true;
        this.searchCriteria.Address = params['TenantName'];
        this.searchCriteria.AddressTypeId = 0;
        this.searchCriteria.AddressType = 1;
        this.searchCriteria.AddressTypeName = "Tenant";

        this.searchCriteria.Brokerages = [];
        this.searchCriteria.PropertyFor = 602;
        this.propertySearchCriteria(this.searchCriteria);
      }
      else {
        this.hasBrokerageFilter = false;
        this.searchCriteria.Brokerages = [];
        this.hasTenantFilter = false;
        this.searchCriteria.Address = "";
        this.searchCriteria.AddressTypeId = 0;
        this.searchCriteria.AddressType = 0;
        this.searchCriteria.AddressTypeName = null;
        this.searchCriteria.PropertyStatus = []
      }
    });
    this._propertyListingService.criteria.PropertyFor = 0;
    this.searchCriteria = this._propertyListingService.criteria;
    this.user = this.authService.user;
    var loggedinUserId = this.user.Id;
    const that = this;
    this.role = this.user.Role;
    this.reassignSelectedRows();
    this.BindColumns();
    if (this.authService.IsUserRole(this.authService.UserRole.Admin) || this.authService.IsUserRole(this.authService.UserRole.SuperAdmin) || this.authService.IsUserRole(this.authService.UserRole.Broker)) {
      this.dataColums = [{ data: 'PropertyName' },
      { data: 'PropertyName' },
      { data: 'PropertySequenceId' },
      { data: 'PropertyName' },
      { data: 'State' },
      { data: 'City' },
      { data: 'BrokerCount' },
      { data: 'PropertyStatus' },
      { data: 'Price' },
      { data: 'RentNOI' },
      { data: 'CreditRating' },
      { data: 'CapRate' },
      { data: 'RemainingTerm' },
      { data: 'LeaseStructure' },
      { data: 'BuildingSize' },
      { data: 'Rank' }]

      this.dtOptions = {
        pagingType: 'full_numbers',
        serverSide: true,
        processing: true,
        info: false,
        language: {
          zeroRecords: null,
          processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
        },
        "pageLength": 50,
        bLengthChange: false,
        stateSave: true,
        stateSaveCallback: function (settings, data) {
          localStorage.setItem("DataTables_archive_list_view", JSON.stringify(data));
        },
        stateLoadCallback: function (settings) {
          let localStorageName = "DataTables_archive_list_view";
          $(".dataTables_paginate.paging_full_numbers").show();
          let data = JSON.parse(localStorage.getItem(localStorageName));
          if (data != null) {
            if (that.searchCriteria.AddressType == 1) {
              var tableStates = JSON.parse(localStorage.getItem('TableStates'));
              if (tableStates != null) {
                tableStates.forEach(item => {
                  if (item.TableName == localStorageName && item.IsSortOrderChanged) {
                    item.IsSortOrderChanged = false;
                    //data.order = [[that.dataColums.findIndex(x => x.data == "Rank"), "desc"]];
                    data.order = [[7, "desc"]];
                  }
                });
                localStorage.setItem('TableStates', JSON.stringify(tableStates));
              }
            }
            else if (data.order[0][0] == that.dataColums.findIndex(x => x.data == "Rank")) {
              data.order = [[7, "desc"]];
            }
          }
          return data;
        },
        initComplete: () => $('.dataTables_filter').css('display', 'none'),
        ajax: (dataTablesParameters: any, callback: Function) => {
          this.IsLoading = true;
          dataTablesParameters.Extra_param = this.searchCriteria;
          dataTablesParameters.Extra_param.IsComp = false;
          dataTablesParameters.Extra_param.IsArchive = true;
          dataTablesParameters.Extra_param.IsExport = false;
          if (!this.hasBrokerageFilter) {
            dataTablesParameters.Extra_param.Brokerages = this._propertyListingService.selectedBrokerage;
          }
          const httpHeader = this.Validation.GetAuthHeader();
          that.http
            .post<DataTablesResponse>(
              this.BASE_URL + '/property/mypropertieslistview/' + loggedinUserId,
              dataTablesParameters, httpHeader
            ).subscribe(resp => {
              that.propertiesEx = resp.data ? resp.data : [];
              that.propertiesEx.forEach(item => {
                item.Remaining_Term = this.Validation.remainingTermForCardandTables(item.LeaseExpiration, item.LeaseCommencementDate);
                if (this.selectedRows.findIndex(x => x.Id == item.Id) > -1) {
                  item.IsSelected = true;
                }
                if (item.CharacteristicsId) {
                  item.capRateText = 'ZCF';
                }
                else {
                  item.capRateText = item.CapRate;
                }
              });

              this.selectAll = false;
              this.autoSelectAll();
              if (that.propertiesEx.length > 0) {
                this.propertyCount = this.propertiesEx[0].TotalCount;
              }
              else {
                this.propertyCount = 0;
              }
              if (resp.data.length === 0) {
                $(".dataTables_paginate.paging_full_numbers").hide()
              }
              if (resp) {
                callback({
                  recordsTotal: resp.recordsTotal,
                  recordsFiltered: resp.recordsFiltered,
                  data: []
                });
              } else {
                callback({
                  recordsTotal: 0,
                  recordsFiltered: 0,
                  data: []
                });
              }
              $(".paginate_button.first,.paginate_button.last").hide();
              this.IsLoading = false;
            });
        },
        columns: this.dataColums
      };
    }
  }

  ngAfterViewInit(): void {
    this.cdRef.detectChanges();
    this.dtTrigger.next(true);
    this.Common.getPropertyStatus().subscribe(response => {
      let propertyStatus = response.map(o => {
        return {
          id: o.Id, description: o.Description
        };
      });
      this.propertyStatusList = propertyStatus.filter(x => x.id !== 354);
    });
  }

  searchCriteriaForExport = {} as IPropertySearchCriteria;
  exportToExcel() {
    this.loaderService.display(true);
    this.searchCriteriaForExport = this.searchCriteria;
    this.searchCriteriaForExport.IsExport = true;
    var loggedinUserId = this.user.Id;
    const inputModel =
    {
      Extra_param: this.searchCriteria
    }

    let dataTablesParameters = inputModel;

    dataTablesParameters.Extra_param = this.searchCriteriaForExport;
    dataTablesParameters.Extra_param.IsArchive = true;
    dataTablesParameters.Extra_param.IsComp = false;
    var newDate = new Date();
    var offset = newDate.getTimezoneOffset() / 60;
    dataTablesParameters.Extra_param.CurrentOffset = offset;
    const httpHeader = this.Validation.GetAuthHeader();
    this.http.post<string>(this.BASE_URL + '/property/mypropertieslistview/' + loggedinUserId, dataTablesParameters, httpHeader).subscribe(resp => {
      let filenameWithExtension: string = resp.toString();
      let filenameWithoutExtension = filenameWithExtension.toString().split('.')[0];
      this.Validation.downloadExcelFile('/upload/excelfile/' + filenameWithoutExtension, 'Archive List.xlsx');
      this.loaderService.display(false);
    });
  }
  statusToChange = 0;
  showSelectStatus = false;
  modalRef: BsModalRef;
  ConfirmationHeading = '';
  confirmBody = '';
  compOrArhive = CompOrArhive.Comp;
  selectAll = false;
  onActionSelect(event, template: TemplateRef<any>, classes, CompOrArchive, AssignBroker, BulkDelete) {
    if (this.selectedRows.length == 0) {
      this._toastService.addToast({ title: 'Error Occurred', msg: 'Please select at least 1 property.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
    }
    else {
      if (this.selectedAction == Actions.ChangeStatus) {
        this.statusToChange = 0;
        this.showSelectStatus = false;
        this.modalRef = this.modalService.show(template, { class: classes });
      }
      else if (this.selectedAction == Actions.MarkAsComp) {
        this.ConfirmationHeading = "Mark as comp";
        this.confirmBody = 'Are you sure to mark the selected ' + this.getSelectedCount() + ' properties as Comp ?'
        this.compOrArhive = CompOrArhive.Comp;
        this.modalRef = this.modalService.show(CompOrArchive, { class: 'deletemodal' });
      }
      else if (this.selectedAction == Actions.MoveToLiveListing) {
        this.ConfirmationHeading = "Move to Live Listing";
        this.confirmBody = 'Are you sure to move the selected ' + this.getSelectedCount() + ' properties to live listing ?'
        this.compOrArhive = CompOrArhive.LiveListing;
        this.modalRef = this.modalService.show(CompOrArchive, { class: 'deletemodal' });
      }
    }
    event.target.value = 0;
  }
  getSelectedCount() {
    //let count = 0;
    //this.propertiesEx.forEach(item => {
    //    if (item.IsSelected) {
    //        count++;
    //    }
    //});
    //return count;
    return this.selectedRows.length;
  }
  onCheckboxChange(event, Id) {
    if (event.target.checked) {
      let prop = this.propertiesEx.find(x => x.Id == Id);
      this.selectedRows.push(prop);
    }
    else {

      this.selectedRows.splice(this.selectedRows.findIndex(x => x.Id == Id), 1);
    }
    this.preserveSelectedRows();
    this.autoSelectAll();
  }

  autoSelectAll() {
    if (this.propertiesEx.filter(x => x.IsSelected == true).length == this.propertiesEx.length && this.propertiesEx.length > 0) {
      this.selectAll = true;
    }
    else {
      this.selectAll = false;
    }
  }
  onSelectAll(event) {
    if (event.target.checked) {
      this.selectOrUnSelectAll(true);
    }
    else {
      this.selectOrUnSelectAll(false);
    }
  }

  selectOrUnSelectAll(trueOrfalse) {
    this.propertiesEx.forEach(item => {
      item.IsSelected = trueOrfalse;
      if (trueOrfalse) {
        // if true then push all selected items into selectedRows collection
        if (this.selectedRows.findIndex(x => x.Id == item.Id) < 0) {
          this.selectedRows.push(item);
        }
      }
      else {
        // if false then current item from the selected row collection
        this.selectedRows.splice(this.selectedRows.findIndex(x => x.Id == item.Id), 1);
      }
    });
    this.preserveSelectedRows();
    if (!trueOrfalse) {
      this.selectAll = false;
    }
  }

  resetSelectedRows() {
    this.selectedRows = [];
    if (this.propertiesEx) {
      this.propertiesEx.forEach(item => {
        item.IsSelected = false;
      });
    }
    this.selectAll = false;
    this.preserveSelectedRows();
  }

  preserveSelectedRows() {
    localStorage.setItem("archivelisting_selectedRows", JSON.stringify(this.selectedRows));
  }
  reassignSelectedRows() {
    if (this.selectedRows.length == 0 && localStorage.getItem("archivelisting_selectedRows") !== null) {
      this.selectedRows = JSON.parse(localStorage.getItem("archivelisting_selectedRows"));
    }
  }

  changeStatus() {

    if (this.statusToChange == Actions.NothingSelected) {
      this.showSelectStatus = true;
    }
    else {
      this.showSelectStatus = false;
      this.loaderService.display(true);
      this.propertyIdList = [];
      this.selectedRows.forEach(item => {
        this.propertyIdList.push(
          {
            PropertyId: item.Id,
            Type: 2
          });
      });
      var loggedinUserId = this.user.Id;
      this._propertyListingService.BulkStatusChange(this.statusToChange, this.propertyIdList, loggedinUserId).subscribe(response => {
        if (response) {
          this.selectOrUnSelectAll(false);
          this.dtElement.dtInstance.then(x => x.draw(false));
          this._toastService.addToast({ title: 'Success', msg: 'Status changed successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
          this.modalRef.hide();
        }
        else {
          this._toastService.addToast({ title: 'Error Occurred', msg: 'Failed to change status', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
        }
        this.loaderService.display(false);
      });
    }
  }

  markCompOrArchive() {
    this.loaderService.display(true);
    this.propertyIdList = [];
    this.selectedRows.forEach(item => {
      this.propertyIdList.push(
        {
          PropertyId: item.Id,
          Type: 2
        });
    });
    var loggedinUserId = this.user.Id;
    this._propertyListingService.BulkStatusChange(this.compOrArhive, this.propertyIdList, loggedinUserId).subscribe(response => {
      if (response) {
        this.selectOrUnSelectAll(false);
        this.dtElement.dtInstance.then(x => x.draw(false));
        if (this.compOrArhive == CompOrArhive.Comp) {
          this._toastService.addToast({ title: 'Success', msg: 'Successfully marked as Comp', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
        }
        else if (this.compOrArhive == CompOrArhive.LiveListing) {
          this._toastService.addToast({ title: 'Success', msg: 'Successfully moved selected properties into live listings', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
        }
      }
      else {
        this._toastService.addToast({ title: 'Error Occurred', msg: 'Failed to perform selected bulk action', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      }
      this.loaderService.display(false);
    });
  }
  hideColumn(col: number) {
    if (this.selectedColumns.indexOf(col) > -1) {
      return false; // show
    }
    else {
      return true; // hide
    }
  }
  tableColumns: collapseColumns[] = [];
  BindColumns() {
    this.tableColumns = [
      { id: 1, name: 'State' },
      { id: 2, name: 'City' },
      { id: 3, name: 'Broker' },
      { id: 4, name: 'Status' },
      { id: 5, name: 'Asking Price' },
      { id: 6, name: 'Rent NOI' },
      { id: 7, name: 'Credit Rating' },
      { id: 8, name: 'Cap Rate' },
      { id: 9, name: 'Remaining Term' },
      { id: 10, name: 'Lease Structure' },
      { id: 11, name: 'Area (SQ FT)' },
    ]

    //if (this.searchCriteria.AddressType == 1) {
    //    this.tableColumns.push({ id: 13, name: 'Rank' });
    //}

    this.selectedColumns = [];
    if (localStorage.getItem("archive_listings_selectedColumns_LS") !== null) {
      this.selectedColumns = JSON.parse(localStorage.getItem("archive_listings_selectedColumns_LS"));
      if (this.selectedColumns.length == 0) {
        this.bindDefaultColumns();
      }
    }
    else {
      this.bindDefaultColumns();
    }

    //if (this.searchCriteria.AddressType != 1 && this.selectedColumns.indexOf(12) > -1) {
    //    this.cdRef.detectChanges();
    //    this.selectedColumns.splice(this.selectedColumns.indexOf(12), 1);
    //}
    //else if (this.searchCriteria.AddressType == 1 && this.selectedColumns.indexOf(12) == -1) {
    //    this.cdRef.detectChanges();
    //    this.selectedColumns.push(12);
    //}

    //this.cdRef.detectChanges();

    this.onRedirection();
  }



  private bindDefaultColumns() {
    this.tableColumns.forEach(item => {
      this.selectedColumns.push(item.id);
    });
    this.cdRef.detectChanges();
  }
  onRedirection() {
    localStorage.setItem("archive_listings_selectedColumns_LS", JSON.stringify(this.selectedColumns));
  }

  modalRefDuplicate: BsModalRef;
  selectedPropertyIdForDuplicates = 0;
  openModalForDuplicates(template: TemplateRef<any>, classes: any, id) {
    this.selectedPropertyIdForDuplicates = id;
    this.modalRefDuplicate = this.modalService.show(template, { class: classes });
  }
  showPortfolioProperties(id, index) {
    this.searchCriteria.PropertyId = id;
    if (this.propertiesEx[index].PortfolioProperties == undefined || this.propertiesEx[index].PortfolioProperties.length == 0) {
      this.loaderService.display(true);
      this._propertyListingService.GetPortfolioPropertiesList(this.searchCriteria).subscribe(item => {
        this.propertiesEx[index].PortfolioProperties = item;
        this.propertiesEx[index].PortfolioProperties.forEach(item => {
          item.Remaining_Term = this.Validation.remainingTermForCardandTables(item.LeaseExpiration, item.LeaseCommencementDate);
        });
        this.propertiesEx[index].ShowPortfolioProperties = true;
        this.loaderService.display(false);
      })
    }
    else {
      this.propertiesEx[index].ShowPortfolioProperties = !this.propertiesEx[index].ShowPortfolioProperties;
    }
  }

  modalRefRemove: BsModalRef;
  propertyToDelete: string;
  property: string;
  deleteIndex: number;
  IsPortfolio = false as boolean;
  openModal(template: TemplateRef<any>, classes: any, propertyToDelete: string, propertyName: string, index: number) {
    this.propertyToDelete = propertyToDelete;
    this.property = propertyName;
    this.IsPortfolio = this.propertiesEx[index].IsPortfolio;
    this.deleteIndex = index;
    this.modalRefRemove = this.modalService.show(template, { class: classes });
  }

  deleteProperty() {
    let text = this.IsPortfolio ? "Portfolio" : "Property";
    var loggedinUserId = this.user.Id;
    this._propertyListingService.deleteProperty(this.propertyToDelete, loggedinUserId).subscribe(response => {
      if (response) {
        this.propertiesEx.splice(this.deleteIndex, 1);
        let propertyIndexToDelete = this.selectedRows.findIndex(x => x.Guid == this.propertyToDelete);
        if (propertyIndexToDelete > -1) {
          this.selectedRows.splice(propertyIndexToDelete, 1);
          this.preserveSelectedRows();
        }
        this.propertyCount = this.propertyCount - 1;
        this._toastService.addToast({ title: 'Success', msg: text + ' deleted successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
      }
      else {
        this._toastService.showToast({ title: 'Error Occurred', msg: 'Failed to delete ' + text, timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
    });
  }
}
